var map = {
	"./de-DE/txt_result.png": "a2f0",
	"./en-GB/txt_result.png": "c7f4",
	"./en-US/txt_result.png": "6d7e",
	"./es-ES/txt_result.png": "bbaf",
	"./es-MX/txt_result.png": "20bc",
	"./fr-CA/txt_result.png": "b85d",
	"./fr-FR/txt_result.png": "9726",
	"./it-IT/txt_result.png": "03638",
	"./ja-JP/txt_result.png": "8f3d",
	"./pt-BR/txt_result.png": "268d",
	"./zh-TW/txt_result.png": "c8b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb92";